import { render, staticRenderFns } from "./project-tab-purchase-order.vue?vue&type=template&id=386a985a"
import script from "./project-tab-purchase-order.vue?vue&type=script&lang=js"
export * from "./project-tab-purchase-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports